'use client'

import React, { useState } from 'react'
import Heading from '../atoms/Heading'
import Paragraph from '../atoms/Paragraph'
import Section from '../sections/Section'
import { AdvancedButton } from '../atoms/AdvancedButton'
import Icon from '../atoms/Icons'
import Carousel from '../organisms/Carousel'
import { useRouter } from 'next/navigation'
import { motion } from 'motion/react'
import Link from 'next/link'
import { clean } from '~/app/utils/sanitizeString'

const Price = ({ data }) => {
  const router = useRouter()

  // Array of color classes to apply based on index
  const colors = ['bg-gul', 'bg-rødtekst', 'bg-rød']
  const textColor = ['text-rødtekst', 'text-white', 'text-white']
  const PriceColor = ['text-rødtekst', 'text-white', 'text-rødtekst']
  const SubColor = ['text-rødtekst/60', 'text-lys/60', 'text-rødtekst/60']
  const buttonText2 = [
    'Hent detaljeret prisliste',
    'Hent detaljeret prisliste',
    'Anmod om pris',
  ]

  const paddingTop = [
    'pt-12 md:pt-20',
    ' pt-12 md:pt-[6.5rem]',
    'pt-12 md:pt-20',
  ]
  const paddingBottom = ['pb-12', 'pb-[4.5rem]', 'pb-12']
  const height = [
    '' /* min-h-fit md:min-h-[52rem] */,
    '' /* min-h-fit md:min-h-[55rem] */,
    '' /* min-h-fit md:min-h-[52rem] */,
  ]
  const buttonText = ['text-DabraRød', 'text-white', 'text-white']

  return (
    <Section
      variant="lys"
      className=""
      id={`${clean(data?.SectionSettings?.anchor?.current)}`}
    >
      <div className="col-span-full ">
        <div className="pb-8 mx-auto text-center max-w-prose">
          <Heading tag="h2" type="h2" className="">
            {data.title}
          </Heading>
          <Paragraph className="text-center">{data.subtitle}</Paragraph>
        </div>

        <div className="flex items-center justify-between">
          <Carousel
            spaceBetween={16}
            slidesPerView={1}
            breakpoints={{
              0: {
                slidesPerView: 1.1,
                spaceBetween: 20,
              },
              428: {
                // 428px xs:
                slidesPerView: 1.1,
                spaceBetween: 20,
              },
              768: {
                // 768px sm:
                slidesPerView: 2.5,
                spaceBetween: 20,
              },
              1024: {
                // 1024px md:
                slidesPerView: 2.5,
                spaceBetween: 24,
              },
              1280: {
                // 1280px lg:
                slidesPerView: 3,
                spaceBetween: 24,
              },
              1440: {
                // 1440px xl:
                slidesPerView: 3,
                spaceBetween: 24,
              },
              1920: {
                // 1920px 2xl:
                slidesPerView: 3,
                spaceBetween: 24,
              },
              2500: {
                // 2500px 3xl:
                slidesPerView: 3,
                spaceBetween: 24,
              },
            }}
          >
            {data.prices &&
              data.prices.map((box, index) => (
                <motion.div
                  initial={{ opacity: 0, y: 0 }}
                  animate={{ opacity: 1, y: 20 }}
                  exit={{ opacity: 0, y: 0 }}
                  transition={{
                    duration: 0.5,
                    delay: index * 0.25,
                    ease: [0.76, 0, 0.24, 1],
                  }}
                  key={box._key}
                  // Apply the color based on the index
                  className={` px-6 md:px-4 xl:px-16 rounded-lg w-full h-full
                    ${colors[index % colors.length]} 
                    ${textColor[index % textColor.length]}
                    ${paddingTop[index % paddingTop.length]}
                    ${paddingBottom[index % paddingBottom.length]}
                    ${height[index % height.length]}
                    prose-headings:${textColor[index % textColor.length]} `}
                >
                  {/* Make the box take full height and align content vertically */}
                  <div className="flex flex-col justify-between h-full">
                    <div>
                      {/* Title for each box */}
                      <Heading tag="h3" type="h3" spacing="none">
                        {box.title}
                      </Heading>
                      {/* Subtitle for each box */}
                      <Paragraph
                        className={`pt-2 font-medium text-small
                    ${SubColor[index % SubColor.length]}`}
                      >
                        {box.subtitle}
                      </Paragraph>

                      {/* Bullet Points */}
                      <ul className="pt-8">
                        {box.bullets.map((bullet, bulletIndex) => (
                          <div
                            key={bulletIndex}
                            className="flex items-center justify-start pb-4"
                          >
                            <Icon type="check" className="mr-3 shrink-0 " />
                            <Paragraph>
                              <li className="">{bullet}</li>
                            </Paragraph>
                          </div>
                        ))}
                      </ul>
                    </div>

                    <div className="h-auto">
                      {/* Price */}
                      <Heading
                        tag="h4"
                        type="h4"
                        className="my-4 text-3xl font-bold"
                      >
                        Fra kr. {box?.Price}
                      </Heading>
                      <Paragraph className="font-medium text-small">
                        {box?.description}
                      </Paragraph>

                      <div
                        className={`mt-6 font-sans ${buttonText[index % buttonText.length]}`}
                      >
                        <AdvancedButton
                          variant="default"
                          className="w-full my-2"
                          // Pass the subtitle when "Kontakt os nu" is clicked
                          onClick={() => {
                            router.push(
                              `/contact-form-mindkvplan?option=${encodeURIComponent(box.subtitle)}`,
                            )
                          }}
                        >
                          {buttonText2[index]}
                        </AdvancedButton>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
          </Carousel>
        </div>
      </div>
    </Section>
  )
}

export default Price
